// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/financial_plan.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Date } from "./date";
import { Event } from "./events";
import { Action } from "./actions";
/**
 * The engine's plan output: facts only (architecture-redesign.md item I). Balances, every action and
 * every event for the whole plan, plus quantities only the simulation knows. Every summary (totals,
 * net worth, completion averages, cash-flow groupings) is computed by the client's plan-view
 * functions. The same shape is used for the Abi plan and the current-trajectory plan.
 *
 * @generated from protobuf message core.v1.FinancialPlanData
 */
export interface FinancialPlanData {
    /**
     * @generated from protobuf field: core.v1.PlanMeta meta = 20;
     */
    meta?: PlanMeta;
    /**
     * @generated from protobuf field: repeated core.v1.State year_one_daily_states = 21;
     */
    yearOneDailyStates: State[]; // every day of the first year from meta.start_date
    /**
     * @generated from protobuf field: repeated core.v1.State monthly_states = 22;
     */
    monthlyStates: State[]; // meta.start_date, then every month-end to meta.end_date
    /**
     * @generated from protobuf field: repeated core.v1.Action actions = 18;
     */
    actions: Action[]; // every action, whole plan, from meta.simulated_from
    /**
     * @generated from protobuf field: repeated core.v1.Event events = 23;
     */
    events: Event[]; // every event, whole plan, from meta.simulated_from
    /**
     * @generated from protobuf field: repeated core.v1.Decision decisions = 24;
     */
    decisions: Decision[]; // in date order
}
/**
 * The optimizer's choice; output only, never read back.
 *
 * @generated from protobuf message core.v1.Decision
 */
export interface Decision {
    /**
     * @generated from protobuf field: core.v1.Date date = 1;
     */
    date?: Date;
    /**
     * @generated from protobuf field: core.v1.Decision.Method method = 2;
     */
    method: Decision_Method;
    /**
     * @generated from protobuf field: optional core.v1.Date next_decision_date = 3;
     */
    nextDecisionDate?: Date; // unset = never revisited
    /**
     * @generated from protobuf oneof: kind
     */
    kind: {
        oneofKind: "mortgageRefinance";
        /**
         * @generated from protobuf field: core.v1.Decision.MortgageRefinance mortgage_refinance = 4;
         */
        mortgageRefinance: Decision_MortgageRefinance;
    } | {
        oneofKind: "groupRrspRate";
        /**
         * @generated from protobuf field: core.v1.Decision.GroupRrspRate group_rrsp_rate = 5;
         */
        groupRrspRate: Decision_GroupRrspRate;
    } | {
        oneofKind: "homePurchase";
        /**
         * @generated from protobuf field: core.v1.Decision.HomePurchase home_purchase = 7;
         */
        homePurchase: Decision_HomePurchase;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated core.v1.Decision.Option options = 6;
     */
    options: Decision_Option[]; // METHOD_COUNTERFACTUAL only
}
/**
 * @generated from protobuf message core.v1.Decision.Option
 */
export interface Decision_Option {
    /**
     * @generated from protobuf field: string label = 1;
     */
    label: string;
    /**
     * @generated from protobuf field: double lifetime_utility = 2;
     */
    lifetimeUtility: number;
    /**
     * @generated from protobuf field: bool chosen = 3;
     */
    chosen: boolean;
}
/**
 * @generated from protobuf message core.v1.Decision.MortgageRefinance
 */
export interface Decision_MortgageRefinance {
    /**
     * @generated from protobuf field: string mortgage_uuid = 1;
     */
    mortgageUuid: string;
    /**
     * @generated from protobuf field: bool refinance = 2;
     */
    refinance: boolean;
}
/**
 * @generated from protobuf message core.v1.Decision.GroupRrspRate
 */
export interface Decision_GroupRrspRate {
    /**
     * @generated from protobuf field: string job_uuid = 1;
     */
    jobUuid: string;
    /**
     * @generated from protobuf field: string group_rrsp_uuid = 2;
     */
    groupRrspUuid: string;
    /**
     * @generated from protobuf field: double employee_contribution_rate = 3;
     */
    employeeContributionRate: number; // e.g. 0.05 = 5% of gross pay
}
/**
 * whether to buy a home-buying goal's home on its date (decided with the refinance on the first day);
 * a "buy" still skips when the down payment isn't there on the date (PRIORITY_MISSED says so)
 *
 * @generated from protobuf message core.v1.Decision.HomePurchase
 */
export interface Decision_HomePurchase {
    /**
     * @generated from protobuf field: string priority_uuid = 1;
     */
    priorityUuid: string;
    /**
     * @generated from protobuf field: bool buy = 2;
     */
    buy: boolean;
}
/**
 * @generated from protobuf enum core.v1.Decision.Method
 */
export enum Decision_Method {
    /**
     * @generated from protobuf enum value: METHOD_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: METHOD_COUNTERFACTUAL = 1;
     */
    COUNTERFACTUAL = 1,
    /**
     * @generated from protobuf enum value: METHOD_RULE = 2;
     */
    RULE = 2
}
/**
 * @generated from protobuf message core.v1.PlanMeta
 */
export interface PlanMeta {
    /**
     * @generated from protobuf field: string engine_version = 1;
     */
    engineVersion: string;
    /**
     * @generated from protobuf field: core.v1.PlanMeta.Policy policy = 2;
     */
    policy: PlanMeta_Policy;
    /**
     * @generated from protobuf field: int32 family_version = 3;
     */
    familyVersion: number; // set by the backend: which saved version of the family was the input
    /**
     * @generated from protobuf field: google.protobuf.Timestamp generated_at = 4;
     */
    generatedAt?: Timestamp;
    /**
     * @generated from protobuf field: core.v1.Date start_date = 5;
     */
    startDate?: Date; // the plan's "today"
    /**
     * @generated from protobuf field: core.v1.Date end_date = 6;
     */
    endDate?: Date; // the oldest member reaches the life-expectancy age
    /**
     * Family.facts_as_of. Actions and events between this and start_date are what the engine predicts
     * happened since the facts were recorded (the check-in list); states start at start_date.
     *
     * @generated from protobuf field: core.v1.Date simulated_from = 7;
     */
    simulatedFrom?: Date;
    /**
     * @generated from protobuf field: core.v1.Assumptions assumptions = 8;
     */
    assumptions?: Assumptions;
}
/**
 * @generated from protobuf enum core.v1.PlanMeta.Policy
 */
export enum PlanMeta_Policy {
    /**
     * @generated from protobuf enum value: POLICY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: POLICY_ABI = 1;
     */
    ABI = 1,
    /**
     * @generated from protobuf enum value: POLICY_CURRENT_TRAJECTORY = 2;
     */
    CURRENT_TRAJECTORY = 2
}
/**
 * Effective economic assumptions for the run, so text like "assumes 6% growth" matches it.
 *
 * @generated from protobuf message core.v1.Assumptions
 */
export interface Assumptions {
    /**
     * @generated from protobuf field: double inflation_rate = 1;
     */
    inflationRate: number; // annual, percent
    /**
     * @generated from protobuf field: double salary_growth_rate = 2;
     */
    salaryGrowthRate: number;
    /**
     * @generated from protobuf field: double investment_return_rate = 3;
     */
    investmentReturnRate: number;
    /**
     * @generated from protobuf field: double retirement_confidence = 4;
     */
    retirementConfidence: number; // e.g. 0.95
    /**
     * @generated from protobuf field: int32 life_expectancy_age = 5;
     */
    lifeExpectancyAge: number;
    /**
     * @generated from protobuf field: map<string, double> other = 6;
     */
    other: {
        [key: string]: number;
    }; // any further named assumptions
}
/**
 * @generated from protobuf message core.v1.Balance
 */
export interface Balance {
    /**
     * @generated from protobuf field: string entity_uuid = 1;
     */
    entityUuid: string; // a family entity, or one the plan created (see CreateAccountAction)
    /**
     * @generated from protobuf field: core.v1.EntityKind kind = 2;
     */
    kind: EntityKind;
    /**
     * @generated from protobuf field: string member_uuid = 3;
     */
    memberUuid: string; // owner; empty for household-level entities
    /**
     * @generated from protobuf field: double balance = 4;
     */
    balance: number; // debts are positive amounts owed
    /**
     * @generated from protobuf field: optional double contribution_room = 5;
     */
    contributionRoom?: number; // registered accounts: the owner's room for this account type
    /**
     * @generated from protobuf field: optional double interest_paid_to_date = 6;
     */
    interestPaidToDate?: number; // debts: cumulative interest since meta.start_date
}
/**
 * @generated from protobuf message core.v1.State
 */
export interface State {
    /**
     * @generated from protobuf field: core.v1.Date date = 1;
     */
    date?: Date;
    /**
     * @generated from protobuf field: repeated core.v1.Balance accounts = 2;
     */
    accounts: Balance[];
    /**
     * @generated from protobuf field: repeated core.v1.Balance debts = 3;
     */
    debts: Balance[];
    /**
     * @generated from protobuf field: repeated core.v1.Balance assets = 4;
     */
    assets: Balance[];
}
/**
 * @generated from protobuf enum core.v1.EntityKind
 */
export enum EntityKind {
    /**
     * @generated from protobuf enum value: ENTITY_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_CHEQUING = 1;
     */
    CHEQUING = 1,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_SAVINGS = 2;
     */
    SAVINGS = 2,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_RRSP = 3;
     */
    RRSP = 3,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_TFSA = 4;
     */
    TFSA = 4,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_FHSA = 5;
     */
    FHSA = 5,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_RESP = 6;
     */
    RESP = 6,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_RRIF = 7;
     */
    RRIF = 7,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_NON_REGISTERED = 8;
     */
    NON_REGISTERED = 8,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_DC_PENSION = 9;
     */
    DC_PENSION = 9,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_MORTGAGE = 10;
     */
    MORTGAGE = 10,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_LOAN = 11;
     */
    LOAN = 11,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_CREDIT_CARD = 12;
     */
    CREDIT_CARD = 12,
    /**
     * @generated from protobuf enum value: ENTITY_KIND_PROPERTY = 13;
     */
    PROPERTY = 13
}
// @generated message type with reflection information, may provide speed optimized methods
class FinancialPlanData$Type extends MessageType<FinancialPlanData> {
    constructor() {
        super("core.v1.FinancialPlanData", [
            { no: 20, name: "meta", kind: "message", T: () => PlanMeta },
            { no: 21, name: "year_one_daily_states", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => State },
            { no: 22, name: "monthly_states", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => State },
            { no: 18, name: "actions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Action },
            { no: 23, name: "events", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Event },
            { no: 24, name: "decisions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Decision }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.FinancialPlanData
 */
export const FinancialPlanData = new FinancialPlanData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Decision$Type extends MessageType<Decision> {
    constructor() {
        super("core.v1.Decision", [
            { no: 1, name: "date", kind: "message", T: () => Date },
            { no: 2, name: "method", kind: "enum", T: () => ["core.v1.Decision.Method", Decision_Method, "METHOD_"] },
            { no: 3, name: "next_decision_date", kind: "message", T: () => Date },
            { no: 4, name: "mortgage_refinance", kind: "message", oneof: "kind", T: () => Decision_MortgageRefinance },
            { no: 5, name: "group_rrsp_rate", kind: "message", oneof: "kind", T: () => Decision_GroupRrspRate },
            { no: 7, name: "home_purchase", kind: "message", oneof: "kind", T: () => Decision_HomePurchase },
            { no: 6, name: "options", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Decision_Option }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Decision
 */
export const Decision = new Decision$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Decision_Option$Type extends MessageType<Decision_Option> {
    constructor() {
        super("core.v1.Decision.Option", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "lifetime_utility", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "chosen", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Decision.Option
 */
export const Decision_Option = new Decision_Option$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Decision_MortgageRefinance$Type extends MessageType<Decision_MortgageRefinance> {
    constructor() {
        super("core.v1.Decision.MortgageRefinance", [
            { no: 1, name: "mortgage_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refinance", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Decision.MortgageRefinance
 */
export const Decision_MortgageRefinance = new Decision_MortgageRefinance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Decision_GroupRrspRate$Type extends MessageType<Decision_GroupRrspRate> {
    constructor() {
        super("core.v1.Decision.GroupRrspRate", [
            { no: 1, name: "job_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "group_rrsp_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "employee_contribution_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Decision.GroupRrspRate
 */
export const Decision_GroupRrspRate = new Decision_GroupRrspRate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Decision_HomePurchase$Type extends MessageType<Decision_HomePurchase> {
    constructor() {
        super("core.v1.Decision.HomePurchase", [
            { no: 1, name: "priority_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "buy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Decision.HomePurchase
 */
export const Decision_HomePurchase = new Decision_HomePurchase$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanMeta$Type extends MessageType<PlanMeta> {
    constructor() {
        super("core.v1.PlanMeta", [
            { no: 1, name: "engine_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy", kind: "enum", T: () => ["core.v1.PlanMeta.Policy", PlanMeta_Policy, "POLICY_"] },
            { no: 3, name: "family_version", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "generated_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "start_date", kind: "message", T: () => Date },
            { no: 6, name: "end_date", kind: "message", T: () => Date },
            { no: 7, name: "simulated_from", kind: "message", T: () => Date },
            { no: 8, name: "assumptions", kind: "message", T: () => Assumptions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PlanMeta
 */
export const PlanMeta = new PlanMeta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Assumptions$Type extends MessageType<Assumptions> {
    constructor() {
        super("core.v1.Assumptions", [
            { no: 1, name: "inflation_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "salary_growth_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "investment_return_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "retirement_confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "life_expectancy_age", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "other", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Assumptions
 */
export const Assumptions = new Assumptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Balance$Type extends MessageType<Balance> {
    constructor() {
        super("core.v1.Balance", [
            { no: 1, name: "entity_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["core.v1.EntityKind", EntityKind, "ENTITY_KIND_"] },
            { no: 3, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "contribution_room", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "interest_paid_to_date", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Balance
 */
export const Balance = new Balance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class State$Type extends MessageType<State> {
    constructor() {
        super("core.v1.State", [
            { no: 1, name: "date", kind: "message", T: () => Date },
            { no: 2, name: "accounts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Balance },
            { no: 3, name: "debts", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Balance },
            { no: 4, name: "assets", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Balance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.State
 */
export const State = new State$Type();
